module.exports = __webpack_public_path__ + "img/logoNovaccess2.2ad04edc.svg";